import { render } from "./ListInvoiceInventoryDetails.vue?vue&type=template&id=3a1682fb"
import script from "./ListInvoiceInventoryDetails.vue?vue&type=script&lang=js"
export * from "./ListInvoiceInventoryDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__